import React, { Component } from "react";

import ComponentHOC from "../hoc/ComponentHOC";
import PropTypes from "prop-types";
//Components imports
import VideoCardItem from "./video-card";
import Videos from "../models/videos";
import { connect } from "react-redux";

class VideoComponent extends Component {
  constructor() {
    super();
    this.state = {
      colSize: 2,
    };
  }

  getTitleName(title) {
    var name = title.toLowerCase().replace(/ +/g, "-");
    return name;
  }
  render() {
    const { list } = this.props;
    const { colSize } = this.state;

    return (
      <section className="entertainment-section">
        <div className="container">
          <div className="row entertainment-card-list">
            {list.map((cardItem, index) => {
              var item = new Videos(cardItem);
              // if(window.location.pathname === "/" && index >= colSize)
              //     return null
              return (
                <VideoCardItem
                  key={item.id}
                  src={item.src}
                  title={item.title}
                  width={12 / colSize}
                  link={`videos/${item.id}/${this.getTitleName(item.title)}`}
                />
              );
            })}
          </div>
        </div>
      </section>
    );
  }
}
VideoComponent.propType = {
  size: PropTypes.number,
  list: PropTypes.array.isRequired,
};

export default connect((state) => state)(ComponentHOC(VideoComponent));



// WEBPACK FOOTER //
// ./src/components/videos.js